<template>
  <form @submit.prevent="save">
    <b-message type="is-danger" v-if="errors.length > 0">
      <p v-for="error in errors">{{error}}</p>
    </b-message>
    <div class="columns is-multiline">
      <div class="column is-6">
        <b-field>
          <form-input :label="`${$t('admin.name')}(ru) *`" v-model="form.name_ru"></form-input>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field>
          <form-input :label="`${$t('admin.name')}(uz) *`" v-model="form.name_uz"></form-input>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field>
          <form-input :label="`${$t('admin.abbr')} *`" v-model="form.abbr"></form-input>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field>
          <form-select :label="`${$t('admin.registerBook')} *`" v-model="form.register_book">
            <option v-for="registerBook in relations.register_books" :value="registerBook.id">
              {{ registerBook.name }}
            </option>
          </form-select>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field>
          <form-select :label="$t('admin.analytic_dimension')" v-model="form.analytic_dimension">
            <option v-for="ad in relations.analytic_dimensions" :value="ad.id">
              {{ ad.name }}
            </option>
          </form-select>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field>
          <form-select :label="`${$t('admin.category')} *`" v-model="form.category">
            <option value="incoming">{{ $t('admin.docTypeCategory.incoming') }}</option>
            <option value="outgoing">{{ $t('admin.docTypeCategory.outgoing') }}</option>
            <option value="appeal">{{ $t('admin.docTypeCategory.appeal') }}</option>
          </form-select>
        </b-field>
      </div>
      <div class="column is-1">
        <b-field>
          <form-input type="number" :label="$t('admin.weight')" v-model="form.weight"></form-input>
        </b-field>
      </div>
      <div class="column is-12">
        <div class="field is-grouped mt-10">
          <div class="control">
            <button type="submit" class="button is-primary">{{ $t('interface.save') }}</button>
          </div>
          <div class="control">
            <button class="button is-danger" @click.prevent="cancel">{{ $t('interface.cancel') }}</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import {mapState} from 'vuex'

  const defaultData = {
    name_ru: '',
    name_uz: '',
    abbr: '',
    register_book: null,
    category: null,
    weight: 0,
    analytic_dimension: null
  }

  export default {
    props: ['data', 'editMode'],
    data() {
      return {
        form: this.data || {...defaultData},
        isEdit: this.editMode || false,
        errors: []
      }
    },
    methods: {
      validate() {
        let isValid = true
        this.errors = []
        if (this.form.name_ru === '' || this.form.name_uz === '' || this.form.abbr === '' || this.form.register_book === null) {
          this.errors.push(this.$t('interface.requiredFields'))
          isValid = false
        }
        return isValid
      },
      save() {
        if (this.validate()) {
          this.$emit('save', this.form)
        }
      },
      cancel() {
        this.$router.go(-1)
      }
    },
    computed: {
      ...mapState('Moderator', ['relations'])
    },
    watch: {
      data(data) {
        this.form = data
      }
    }
  }
</script>
